const sortingTypes = [
    { code: 'titleAZ', name: 'Naam (A-Z)' },
    { code: 'titleZA', name: 'Naam (Z-A)' },
    { code: 'lastUpdated', name: 'Laatst gewijzigd' },
];

export default sortingTypes;
